import reducer from './reducers'
export { default as types } from './types'
export { default as actions } from './actions'

export default reducer
